// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2M9gv","modalContent":"style_modalContent__3tGzM"};